import gql from 'graphql-tag';

export const SAVE_GENERATED_CONTENT = gql`
  mutation SaveGeneratedContent($input: GenerateContentInput!) {
    saveGeneratedContent(input: $input)
  }
`;
